import { getRunMode } from '@/utils';
import type { FeatureFlagKey } from '@/utils/feature-flag';
import { FeatureFlagService, featureFlagsConfig } from '@/utils/feature-flag';

/**
 * feature flag 활성화 여부
 *
 * @param featureName - feature flag key
 * @returns feature flag가 활성화되어 있는지 여부
 */
export const isFeatureEnabled = (featureName: FeatureFlagKey): boolean => {
  const featureFlagService = new FeatureFlagService(featureFlagsConfig, getRunMode());

  return featureFlagService.isFeatureEnabled(featureName);
};
